import { Button } from '@optools/components/ui/button';
import { DialogClose, DialogFooter } from '@optools/components/ui/dialog';
import { CircleCheck } from 'lucide-react';

export function BulkAssetUpdatesSuccess() {
  return (
    <div>
      <div className="mb-6 flex flex-col items-center">
        <CircleCheck className="mb-2 size-8 text-green-600" />
        <h2>Bulk Update Success</h2>
        <p className="text-sm text-primary/80">The asset states have successfully been updated.</p>
      </div>
      <DialogFooter>
        <DialogClose asChild>
          <Button>Close</Button>
        </DialogClose>
      </DialogFooter>
    </div>
  );
}
